export const MODULE_STORE_KEY = 'modules';
export const STARTING_MODULE_STORE_KEY = 'startingModules';
export const CURRICULUM_MODULE_STORE_KEY = 'curriculumModules';
